export default function buildBaseEndpoint({ view, tab, isEvidence, isMapping, mappingContent }) {
  //  Tab segment logic
  let tabSegment = tab?.toLowerCase().replace(/s$/, '');
  tabSegment = tabSegment === 'chemical' ? 'chem' : tabSegment;

  // View segment logic
  let viewSegment = '' as string;
  viewSegment = view === 'ALL' ? '/all' : '/summary';
  viewSegment = ['VDA', 'GDA'].includes(tab as string) ? '/summary' : viewSegment;
  viewSegment = tab === 'DDA' ? '' : viewSegment; // DDA has its own backend pattern
  viewSegment = tab === 'DISEASES' ? '/all' : viewSegment; // disease/all with disease_filter
  viewSegment = ['GENES', 'VARIANTS', 'CHEMICALS'].includes(tab as string) ? '/all' : viewSegment; // entity list tabs
  viewSegment = isEvidence === true ? '' : viewSegment;

  // If mappingContent is provided, override segments
  if (isMapping && mappingContent) {
    tabSegment = mappingContent.tabSegment || tabSegment;
    if (tabSegment.includes('shared')) {
      viewSegment = '';
    } else if (isEvidence) {
      if (tabSegment.startsWith('chem/')) {
        tabSegment = tabSegment.replace(/^chem\//, '');
      }
      viewSegment = '';
    } else {
      if (tabSegment === 'gda' || tabSegment === 'vda') {
        viewSegment = '/summary';
      } else {
        viewSegment = mappingContent.viewSegment === '/all' ? '/all' : '/summary';
      }
    }
  }

  const baseEndpoint = `api/${tabSegment}${viewSegment}`;

  return baseEndpoint;
}
